(function (w) {
  'use strict';

  // Rx products are made-to-order and intentionally continue selling at zero,
  // so their Shopify `available` flag cannot represent real frame inventory.
  // Each Rx frame instead follows the matching retail product/frame colour.
  // option1/option2 pin a rule to one frame colour; a rule without them matches
  // any variant of the product and is only used when no pinned rule matches.
  var rules = {
    'the-hook-rx': { product: 'titanium-sunglasses' },
    'the-champagne-gold-hook-rx': { product: 'the-gold-hook', option1: 'Champagne' },
    'the-black-gold-hook-rx': { product: 'the-gold-hook', option1: 'Black Gold' },
    'the-black-empire-rx': { product: 'the-empire', option1: 'Black' },
    'the-black-gold-empire-rx': { product: 'the-empire', option1: 'Black Gold' },
    'the-black-oasis': { product: 'the-oasis', option1: 'Black-Black' },
    'the-black-gold-oasis-rx': { product: 'the-oasis', option1: 'Black Gold' },
    'the-tortoise-black-oasis-rx': { product: 'the-oasis', option1: 'Tortoise-Black' },
    'the-tortoise-gold-oasis-rx': { product: 'the-oasis', option1: 'Tortoise Gold' },
    'the-black-hughes-rx': { product: 'the-hughes', option1: 'Black/Black' },
    'the-gold-hughes-rx': { product: 'the-hughes', option1: 'Gold/Brown' },
    'the-black-constellation-rx': { product: 'the-constellation', option1: 'Black/Black' },
    'the-gold-constellation-rx': { product: 'the-constellation', option1: 'Gold/Brown' },
    'the-black-level': { product: 'the-level' },
    'the-gold-level-1': { product: 'the-gold-level' },
    'the-acetate-level-rx': { product: 'the-level-acetate' },
    'the-lume-rx': { product: 'the-lume' },
    'the-sloan-rx': { product: 'the-sloan' },
    // The Sloan's second option mixes lens and frame colours; Tortoise is the frame.
    'the-tortoise-sloan-rx': { product: 'the-sloan', option2: 'Tortoise' },
    // Takes prescription and nonprescription lenses (owner, 2026-09-29).
    'the-wrap-rx': { product: 'the-wrap-around' }
  };

  function variantOption(variant, n) {
    return variant && (variant['option' + n] || (variant.options && variant.options[n - 1])) || '';
  }

  function matches(variant, rule) {
    return (!rule.option1 || variantOption(variant, 1) === rule.option1)
      && (!rule.option2 || variantOption(variant, 2) === rule.option2);
  }

  function ruleForRx(rxHandle) {
    return rules[rxHandle] || null;
  }

  // Real stock for a retail variant from the builder's server-rendered map
  // ({ product handle: { variant id: bool } }, sections/rx-builder.liquid). Colours on preorder
  // stay `available`, so the map decides. No map, or no entry: fall back to `available` alone
  // and say so once in the console.
  var warned = false;
  function inStock(stock, productHandle, variant) {
    if (!stock) return true;
    var p = stock[productHandle], v = p && p[String(variant.id)];
    if (typeof v === 'boolean') return v;
    if (!warned && w.console) { warned = true; console.info('[rx-frame-inventory] No stock entry for ' + productHandle + ' variant ' + variant.id + '; using the available flag. Add the product to snippets/rx-frame-stock-handles.liquid.'); }
    return true;
  }

  function sourceAvailable(product, rule, stock) {
    if (!product || !rule || !product.variants) return false;
    return product.variants.some(function (variant) {
      return variant.available && matches(variant, rule) && inStock(stock, product.handle, variant);
    });
  }

  function rxHandleForVariant(productHandle, variant) {
    var handles = Object.keys(rules);
    var generic = null;
    for (var i = 0; i < handles.length; i++) {
      var handle = handles[i];
      var rule = rules[handle];
      if (rule.product !== productHandle) continue;
      if (!rule.option1 && !rule.option2) { generic = handle; continue; }
      if (matches(variant, rule)) return handle;
    }
    return generic;
  }

  w.WPRxFrameInventory = {
    rules: rules,
    ruleForRx: ruleForRx,
    sourceAvailable: sourceAvailable,
    inStock: inStock,
    rxHandleForVariant: rxHandleForVariant
  };
})(window);
